export default __webpack_public_path__ + "static/media/20.96f576e2.png";